import { createFileRoute } from '@tanstack/react-router';
import { EntryFlowPage } from '@/features/resume-builder/entry';

/** DEV-483 — `Home / Already created / Edit`: "Editar currículo". */
export const Route = createFileRoute('/perfil/curriculo/editar')({
  component: () => <EntryFlowPage mode="edit" />,
});
